<template>
  <v-snackbar color="warning" location="top" :model-value="!!globalNotice" :timeout="-1" multi-line vertical>
    <div role="status">{{ globalNotice }}</div>
    <template #actions>
      <v-btn variant="text" @click="setGlobalNotice('')">Dismiss</v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { Namespace } from '@/store/types'
import { Mutation, State } from '@/utils/vuex-decorators'
import { Component, Vue } from 'vue-facing-decorator'

@Component({})
export default class GlobalNotice extends Vue {
  @State('globalNotice', { namespace: Namespace.Utils }) public globalNotice!: string
  @Mutation('setGlobalNotice', { namespace: Namespace.Utils }) public setGlobalNotice!: (notice: string) => void
}
</script>
